var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner-page" },
    [
      _c(
        "cargo-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "dialog",
          attrs: {
            "custom-class": "write-off-dialog write-off-dialog-margin",
            visible: _vm.visible,
            "close-on-click-modal": false,
            "show-close": false,
            title: _vm.title,
            width: "1150px",
            "can-maximize": true,
            "can-minimize": true
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            close: _vm.cancel,
            fullscreen: _vm.fullscreenChange
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid-dialog",
              staticStyle: {
                width: "100%",
                "min-height": "210px",
                "padding-bottom": "0"
              }
            },
            [
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "show-right": _vm.dgCharge.show,
                    "left-style": { "min-width": "20%" },
                    "right-style": { "min-width": "80%" }
                  }
                },
                [
                  _c("div", { attrs: { slot: "left" }, slot: "left" }, [
                    _vm.properties.isHedge
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("WriteOff.receivables")))
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "app-main-inner-row row-grid-dialog",
                        staticStyle: { "min-height": "210px", padding: "0" }
                      },
                      [
                        _c("cargo-ag-grid-wrapper", {
                          staticStyle: { width: "100%", "min-height": "180px" },
                          attrs: {
                            "config-module": _vm.dgCharge.show
                              ? ""
                              : "19070801",
                            "show-side-bar": !_vm.dgCharge.show,
                            "grid-options": _vm.dgGroup.gridOptions,
                            "column-defs": _vm.dgGroup.columnDefs,
                            "row-data": _vm.properties.selectedEntities,
                            "auto-fit-content": false
                          },
                          on: { gridReady: _vm.onGridReady_dgGroup }
                        })
                      ],
                      1
                    ),
                    _vm.properties.isHedge
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("WriteOff.payables")))
                        ])
                      : _vm._e(),
                    _vm.properties.isHedge
                      ? _c(
                          "div",
                          {
                            staticClass: "app-main-inner-row row-grid-dialog",
                            staticStyle: { "min-height": "180px", padding: "0" }
                          },
                          [
                            _c("cargo-ag-grid-wrapper", {
                              staticStyle: {
                                width: "100%",
                                "min-height": "180px"
                              },
                              attrs: {
                                "config-module": _vm.dgCharge.show
                                  ? ""
                                  : "19070802",
                                "show-side-bar": !_vm.dgCharge.show,
                                "grid-options": _vm.dgHedge.gridOptions,
                                "column-defs": _vm.dgHedge.columnDefs,
                                "row-data":
                                  _vm.properties.selectedEntitiesHedge,
                                "auto-fit-content": false
                              },
                              on: { gridReady: _vm.onGridReady_dgHedge }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid-dialog",
                      staticStyle: {
                        height: "100%",
                        "min-height": "180px",
                        padding: "0"
                      },
                      attrs: { slot: "right" },
                      slot: "right"
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "config-module": "19070803",
                          "grid-options": _vm.dgCharge.gridOptions,
                          "column-defs": _vm.dgCharge.columnDefs,
                          "row-data": _vm.dgChargeRowData
                        },
                        on: { gridReady: _vm.onGridReady_dgCharge }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "inner-row-border-bottom",
                    staticStyle: {
                      width: "100%",
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "text-align": "right",
                          "margin-right": "-10px"
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.$t("WriteOff.total")))]),
                        _vm.reCalc
                          ? _c("charge-currency-total-group", {
                              key: 1,
                              attrs: {
                                mode: "group",
                                type: "revenueAbs",
                                "data-field": "amount",
                                "rate-field": "writeoffRate",
                                "currency-field": "currency",
                                "ar-field": "isReceivable",
                                source: "Writeoff",
                                "data-provider": _vm.properties.allEntities,
                                "amount-to-currency": _vm.currencyTotal
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.properties.isHedge
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "red",
                              "padding-left": "10px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.lbArAlert))]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dgCharge.show === true,
                            expression: "dgCharge.show===true"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "1" },
                            on: { change: _vm.confirmedChargeChangeHandler },
                            model: {
                              value: _vm.cbConfirmedCharge,
                              callback: function($$v) {
                                _vm.cbConfirmedCharge = $$v
                              },
                              expression: "cbConfirmedCharge"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("WriteOff.confirmedCharge")))
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "text-align": "right",
                          "margin-right": "-10px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dgCharge.show === true,
                                expression: "dgCharge.show===true"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.$t("WriteOff.subTotal")))]
                        ),
                        _vm.reCalc
                          ? _c("charge-currency-total-group", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.dgCharge.show === true,
                                  expression: "dgCharge.show===true"
                                }
                              ],
                              key: 2,
                              attrs: {
                                mode: "group",
                                type: "revenueAbs",
                                "data-field": "currentVerifiedAmount",
                                "rate-field": "writeoffRate",
                                "currency-field": "currency",
                                "ar-field": "isReceivable",
                                source: "Writeoff",
                                "data-provider": _vm.subtotalGroup,
                                "amount-to-currency": _vm.currencyTotal
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": _vm.$selectByLang("60px", "90px"),
                      "label-position": "left"
                    }
                  },
                  [
                    _c("div", { staticClass: "inner-row-border-bottom" }, [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("WriteOff.rateBy"),
                                "label-width": _vm.$selectByLang("", "140px")
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { no: "2" },
                                  on: { change: _vm.rateByChangeHandler },
                                  model: {
                                    value: _vm.rateBy,
                                    callback: function($$v) {
                                      _vm.rateBy = $$v
                                    },
                                    expression: "rateBy"
                                  }
                                },
                                [
                                  [2, 3, 4, 5].includes(
                                    _vm.properties.writeOffMode
                                  )
                                    ? _c(
                                        "el-radio",
                                        { attrs: { label: "invoice" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.rateByInvoice) + " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "average" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("WriteOff.rateByAverage"))
                                      )
                                    ]
                                  ),
                                  _vm.properties.writeOffMode === 1
                                    ? _c(
                                        "el-radio",
                                        { attrs: { label: "charge" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("WriteOff.rateByCharge")
                                            ) + " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.rateBy === "average" &&
                          _vm.properties.otherCurrencyRate.length > 0
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("WriteOff.otherCurrency"),
                                    "label-width": _vm.$selectByLang(
                                      "",
                                      "100px"
                                    )
                                  }
                                },
                                [
                                  _vm.properties.otherCurrencyRate.length > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "padding-right": "6px"
                                          }
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(_vm._s(_vm.lbOtherCurrency1))
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.properties.otherCurrencyRate.length > 0
                                    ? _c("num-input", {
                                        staticStyle: { width: "100px" },
                                        attrs: {
                                          no: "3",
                                          precision: 8,
                                          "truncated-precision":
                                            _vm.txtOtherRate1Precision,
                                          min: 0,
                                          max: 999999999999
                                        },
                                        on: {
                                          change: _vm.otherRate1ChangeHandler
                                        },
                                        model: {
                                          value: _vm.txtOtherRate1,
                                          callback: function($$v) {
                                            _vm.txtOtherRate1 = $$v
                                          },
                                          expression: "txtOtherRate1"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.properties.otherCurrencyRate.length > 1
                                    ? _c(
                                        "span",
                                        { staticStyle: { padding: "0 6px" } },
                                        [
                                          _c("b", [
                                            _vm._v(_vm._s(_vm.lbOtherCurrency2))
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.properties.otherCurrencyRate.length > 1
                                    ? _c("num-input", {
                                        staticStyle: { width: "100px" },
                                        attrs: {
                                          no: "4",
                                          precision: 8,
                                          "truncated-precision":
                                            _vm.txtOtherRate2Precision,
                                          min: 0,
                                          max: 999999999999
                                        },
                                        on: {
                                          change: _vm.otherRate2ChangeHandler
                                        },
                                        model: {
                                          value: _vm.txtOtherRate2,
                                          callback: function($$v) {
                                            _vm.txtOtherRate2 = $$v
                                          },
                                          expression: "txtOtherRate2"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w180" },
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("WriteOff.lastTimeBalance")
                                },
                                slot: "label"
                              }),
                              _c("el-input-number", {
                                staticStyle: { width: "140px" },
                                attrs: {
                                  no: "5",
                                  "controls-position": "right",
                                  disabled: true,
                                  precision: 2,
                                  step: 1,
                                  min: -999999999999,
                                  max: 999999999999
                                },
                                model: {
                                  value: _vm.totalAmount,
                                  callback: function($$v) {
                                    _vm.totalAmount = $$v
                                  },
                                  expression: "totalAmount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass:
                                "el-form-item-w180 custom-el-form-item-color-red"
                            },
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("WriteOff.thisTimeWriteOff")
                                },
                                slot: "label"
                              }),
                              _c("el-input-number", {
                                staticStyle: { width: "140px" },
                                attrs: {
                                  no: "6",
                                  "controls-position": "right",
                                  disabled: true,
                                  precision: 2,
                                  step: 1,
                                  min: -999999999999,
                                  max: 999999999999
                                },
                                model: {
                                  value: _vm.totalVerifyAmount,
                                  callback: function($$v) {
                                    _vm.totalVerifyAmount = $$v
                                  },
                                  expression: "totalVerifyAmount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass:
                                "el-form-item-w180 custom-el-form-item-color-green"
                            },
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("WriteOff.thisTimeBalance")
                                },
                                slot: "label"
                              }),
                              _c("el-input-number", {
                                staticStyle: { width: "140px" },
                                attrs: {
                                  no: "7",
                                  "controls-position": "right",
                                  disabled: true,
                                  precision: 2,
                                  step: 1,
                                  min: -999999999999,
                                  max: 999999999999
                                },
                                model: {
                                  value: _vm.totalRemainAmount,
                                  callback: function($$v) {
                                    _vm.totalRemainAmount = $$v
                                  },
                                  expression: "totalRemainAmount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w180" },
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t(
                                    "WriteOff.preExchangeDifference"
                                  )
                                },
                                slot: "label"
                              }),
                              _c("el-input-number", {
                                staticStyle: { width: "140px" },
                                attrs: {
                                  no: "8",
                                  "controls-position": "right",
                                  disabled: true,
                                  precision: 2,
                                  step: 1,
                                  min: -999999999999,
                                  max: 999999999999
                                },
                                model: {
                                  value: _vm.preExchangeDifference,
                                  callback: function($$v) {
                                    _vm.preExchangeDifference = $$v
                                  },
                                  expression: "preExchangeDifference"
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.properties.bankSlip
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showRecordButton,
                                      expression: "showRecordButton"
                                    }
                                  ],
                                  staticStyle: {
                                    "margin-right": "16px",
                                    position: "absolute",
                                    right: "0"
                                  },
                                  attrs: { type: "primary", no: "9" },
                                  on: {
                                    click: _vm.useActualAmountRecordHandler
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.useActualAmountRecordLabel) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "inner-row-border-bottom" },
                      [
                        _c(
                          "cargo-left-right-resize",
                          {
                            staticStyle: { "min-height": "100%" },
                            attrs: { "left-style": { "flex-grow": "0" } }
                          },
                          [
                            _c(
                              "div",
                              {
                                style: _vm.$selectByLang(
                                  "max-width: 180px;min-width: 150px;",
                                  "max-width: 210px;min-width: 180px;"
                                ),
                                attrs: { slot: "left" },
                                slot: "left"
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass:
                                      "el-form-item-w180 custom-el-form-item-color-red"
                                  },
                                  [
                                    _c("line-label", {
                                      attrs: {
                                        slot: "label",
                                        label: _vm.isAr
                                          ? _vm.$t("WriteOff.receiptAmount")
                                          : _vm.$t("WriteOff.paymentAmount")
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input-number", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        no: "10",
                                        "controls-position": "right",
                                        precision: 2,
                                        step: 1,
                                        min: -999999999999,
                                        max: 999999999999,
                                        disabled:
                                          _vm.rateBy !== "average" &&
                                          _vm.useReceiptRecord
                                      },
                                      on: {
                                        change: _vm.nsActualAmountChangeHandler
                                      },
                                      model: {
                                        value: _vm.nsActualAmount,
                                        callback: function($$v) {
                                          _vm.nsActualAmount = $$v
                                        },
                                        expression: "nsActualAmount"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass:
                                      "el-form-item-w180 custom-el-form-item-color-green"
                                  },
                                  [
                                    _c("line-label", {
                                      attrs: {
                                        slot: "label",
                                        label: _vm.$t(
                                          "WriteOff.exchangeGainsAndLosses"
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input-number", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        no: "11",
                                        "controls-position": "right",
                                        precision: 2,
                                        step: 1,
                                        min: -999999999999,
                                        max: 999999999999
                                      },
                                      model: {
                                        value: _vm.nsDiffChange,
                                        callback: function($$v) {
                                          _vm.nsDiffChange = $$v
                                        },
                                        expression: "nsDiffChange"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass:
                                      "el-form-item-w180 custom-el-form-item-color-green"
                                  },
                                  [
                                    _c("line-label", {
                                      attrs: {
                                        slot: "label",
                                        label: _vm.$t(
                                          "WriteOff.financialCharges"
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input-number", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        no: "12",
                                        "controls-position": "right",
                                        precision: 2,
                                        step: 1,
                                        min: -999999999999,
                                        max: 999999999999
                                      },
                                      model: {
                                        value: _vm.nsFinancialCost,
                                        callback: function($$v) {
                                          _vm.nsFinancialCost = $$v
                                        },
                                        expression: "nsFinancialCost"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass:
                                      "el-form-item-w180 custom-el-form-item-color-green",
                                    attrs: { label: _vm.$t("WriteOff.oddment") }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        no: "13",
                                        "controls-position": "right",
                                        precision: 2,
                                        step: 1,
                                        min: -999999999999,
                                        max: 999999999999
                                      },
                                      model: {
                                        value: _vm.nsClearOdd,
                                        callback: function($$v) {
                                          _vm.nsClearOdd = $$v
                                        },
                                        expression: "nsClearOdd"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.properties.writeOffFinanceChargeShareJob &&
                                _vm.viewSource === "tabNonWriteOffList"
                                  ? [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                disabled: !_vm.nsFinancialCost
                                              },
                                              model: {
                                                value:
                                                  _vm.isFinanceChargeShareJob,
                                                callback: function($$v) {
                                                  _vm.isFinanceChargeShareJob = $$v
                                                },
                                                expression:
                                                  "isFinanceChargeShareJob"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "WriteOff.FinancialExpensesBeAllocated"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.isFinanceChargeShareJob,
                                              expression:
                                                "isFinanceChargeShareJob"
                                            }
                                          ]
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "line-height": "14px",
                                                color: "red"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "WriteOff.FinanceChargeShareJobTip"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.showWhtTax && _vm.isFullWriteOff
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { "margin-top": "10px" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "line-height": "14px",
                                                color: "red"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Clearing.WhtDeduction"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { margin: "0 5px" }
                                            },
                                            [_vm._v(_vm._s(_vm.whtCurrency))]
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.whtAmount.toFixed(2))
                                            )
                                          ])
                                        ]
                                      ),
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "line-height": "14px",
                                              color: "red"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.isAr
                                                  ? _vm.$t(
                                                      "Clearing.ReceivableWHTTaxAmount"
                                                    )
                                                  : _vm.$t(
                                                      "Clearing.PayableWHTTaxAmount"
                                                    )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticStyle: { margin: "0 5px" } },
                                          [_vm._v(_vm._s(_vm.whtCurrency))]
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                (Number(_vm.localAmountSum) ||
                                                  0) - _vm.whtAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      ])
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { attrs: { slot: "right" }, slot: "right" },
                              [
                                _c("cargo-ag-grid", {
                                  staticStyle: {
                                    width: "100%",
                                    "min-width": "900px"
                                  },
                                  attrs: {
                                    "config-module": "190707",
                                    "show-side-bar": false,
                                    "grid-options":
                                      _vm.actualAmountGrid.gridOptions,
                                    "column-defs": _vm.actualAmountColumnDefs,
                                    "row-data": _vm.actualAmountGrid.rowData
                                  },
                                  on: {
                                    gridReady: function(params) {
                                      _vm.actualAmountGrid.gridApi = params.api
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w365",
                            style: _vm.$selectByLang("", "width: auto;"),
                            attrs: {
                              label: _vm.$t("WriteOff.writeOffRemarks"),
                              "label-width": _vm.$selectByLang("", "120px")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "14" },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("WriteOff.writeOffRemarks"),
                                    _vm.txtRemark,
                                    function(val) {
                                      _vm.txtRemarkFinshHandlde(val)
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.txtRemark,
                                callback: function($$v) {
                                  _vm.txtRemark = $$v
                                },
                                expression: "txtRemark"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.showWriteOffHeader
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_WriteOffHeader")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "ourTitle",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .static_data_InvoiceTitle,
                                    filterable: "",
                                    cache: false,
                                    "default-value": _vm.actualAmountTitle,
                                    "static-options": _vm.ourInvoiceTitleArray
                                  },
                                  on: {
                                    parentCallBack:
                                      _vm.actualAmountTitleChangeEvent
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-date-w180",
                            style: _vm.$selectByLang("", "width: auto;"),
                            attrs: {
                              label: _vm.isAr
                                ? _vm.$t("WriteOff.paymentReceivedDate")
                                : _vm.$t("WriteOff.paymentDate"),
                              "label-width": _vm.$selectByLang("", "140px")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "120px" },
                              attrs: {
                                no: "15",
                                type: "date",
                                clearable: false
                              },
                              on: { change: _vm.dfAmountDateChangeHandler },
                              model: {
                                value: _vm.dfAmountDate,
                                callback: function($$v) {
                                  _vm.dfAmountDate = $$v
                                },
                                expression: "dfAmountDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#1a61af",
                                "font-weight": "bold",
                                "padding-left": "10px",
                                "font-size": "14px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("WriteOff.thisTimeWriteOff") +
                                    (_vm.isFinanceChargeShareJob
                                      ? _vm.$t("Clearing.WhenShareFinanceCost")
                                      : "") +
                                    "=" +
                                    (_vm.isAr
                                      ? _vm.$t("WriteOff.receiptAmount")
                                      : _vm.$t("WriteOff.paymentAmount")) +
                                    "+" +
                                    _vm.$t("WriteOff.exchangeGainsAndLosses") +
                                    (_vm.isFinanceChargeShareJob
                                      ? ""
                                      : "+" +
                                        _vm.$t("WriteOff.financialCharges")) +
                                    "+" +
                                    _vm.$t("WriteOff.oddment")
                                )
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.isLoading || _vm.isExecuting,
                    no: "16"
                  },
                  on: { click: _vm.commitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.confirmToWriteOff")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { no: "17" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("WriteOff.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("actual-payment-dialog", {
        attrs: { visible: _vm.actualPaymentDialog.visible },
        on: { selected: _vm.selectedActualPayment }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "app",
            visible: _vm.realSendReceiveDialog.visible,
            title: _vm.$t("WriteOff.selectActualReceiptAndPayment"),
            width: "1000px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            "custom-class": "app-main-content"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.realSendReceiveDialog, "visible", $event)
            }
          }
        },
        [
          _vm.realSendReceiveDialog.visible
            ? _c("write-off-search", {
                ref: "writeOffSearch",
                attrs: {
                  "config-module": "510",
                  "grid-config-module": "191002",
                  ar: _vm.isAr ? 1 : 0,
                  "is-prepay": 1,
                  "account-id": _vm.searchAccountId,
                  "row-selection-type": !_vm.properties.isHedge
                    ? "multiple"
                    : "single",
                  "is-real-send-receive": true,
                  "show-simple": false,
                  "remain-condition": true,
                  "dialog-height": "height: 500px;",
                  "is-dialog": true
                },
                on: { selectionChangedCallBack: _vm.selectionChangedCallBack }
              })
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "18" },
                  on: { click: _vm.enterHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "19" }, on: { click: _vm.cancelHandler } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("finance-charge-share-dialog", {
        attrs: {
          visible: _vm.financeChargeShareDialog.visible,
          receivable: _vm.financeChargeShareDialog.receivable,
          currency: _vm.financeChargeShareDialog.currency,
          "exchange-rate": _vm.financeChargeShareDialog.exchangeRate,
          amount: _vm.financeChargeShareDialog.amount,
          "finance-charge-share-modify": _vm.financeChargeShareModify
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.financeChargeShareDialog, "visible", $event)
          },
          confirmCallback: _vm.financeChargeShareDialog.confirmCallback,
          cancelCallback: _vm.financeChargeShareDialog.cancelCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }